export const MODEL_UNAVAILABLE_ERROR_REASON = 'model_unavailable'
export const NO_SUPPORTED_MODEL_AVAILABLE_ERROR_REASON = 'no_supported_model_available'

export type CreateMessageErrorReason =
  | typeof MODEL_UNAVAILABLE_ERROR_REASON
  | typeof NO_SUPPORTED_MODEL_AVAILABLE_ERROR_REASON
